/**
 * Created by andrey on 20.02.2026
 */

const SyncTransportRest = function (synchronizer) {
    SyncTransport.call(this, synchronizer);
};

SyncTransportRest.prototype = Object.create(SyncTransport.prototype);
SyncTransportRest.prototype.constructor = SyncTransportRest;

SyncTransportRest.prototype._send = function (data, onSuccess, onError) {
    const userId = encodeURIComponent(connector.platform.getUserID());

    const path = `${connector.config.syncApiURL}/sync/${userId}/${this.synchronizer.session}`;

    const adapters = this.synchronizer.adapters;

    if (adapters.header) {
        data.header = adapters.header.getInfo();
    }

    ConnectorRestClient.post(path, data, onSuccess, onError);
};

SyncTransportRest.prototype._checkSession = function (data, onSuccess, onError) {
    const userId = encodeURIComponent(connector.platform.getUserID());

    const path = `${connector.config.syncApiURL}/newsync/${userId}/${this.synchronizer.session}`;

    ConnectorRestClient.post(path, data, (response) => {
        response.session = response.session || response.key;
        response.snapshot = response.snapshot || response.sync;
        onSuccess(response);
    }, onError);
};

SyncTransportRest.isAppropriate = function () {
    return true;
};